import { CheckCircleTwoTone } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { GiSandsOfTime } from 'react-icons/gi';
import { MdDomainDisabled } from 'react-icons/md';

export const verificationMapper = (theme: any) => ({
	verified: (
		<Tooltip title="Joined and Verified!">
			<CheckCircleTwoTone style={{ fontSize: '21px' }} twoToneColor={theme.TA_GREEN_BLUE} />
		</Tooltip>
	),
	pending: (
		<Tooltip title="Pending Processing">
			<GiSandsOfTime style={{ fontSize: '21px', color: theme.TA_WARNING }} />
		</Tooltip>
	),
	notInterested: (
		<Tooltip title="Not Interested">
			<MdDomainDisabled style={{ fontSize: '21px', color: theme.TA_DISABLED }} />
		</Tooltip>
	)
});
